import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

var _createAction;

import { FTUE_STEPS_KEYS } from '../../constants';
import QueryParamProxy from '../../utils/queryParamProxy';
import routeParamConstants from '../../utils/routeParamConstants';
import { TUTORIAL_NAME } from '../../utils/tutorial';
import { ACTION_COMMANDS_TYPE } from './constants/types';
import { getScreenByModalType, getTooltipByType } from './utils';

var handleDisplayModalAction = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var modal, actionCommands;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            modal = _ref.modal;
            actionCommands = QueryParamProxy.setQueryParamsWithModalPromise(_defineProperty({}, routeParamConstants.PARAM_MODAL, getScreenByModalType[modal.modalType] || getScreenByModalType['default']));
            _context.next = 4;
            return actionCommands;

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleDisplayModalAction(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var handleDisplayTooltipAction = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(actionCommands, props) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            getTooltipByType[actionCommands.tooltip.tooltipType](actionCommands, props) || getTooltipByType['default'];

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function handleDisplayTooltipAction(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();

var handleDisplayGameTutorialAction = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(actionCommand, props) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            props.setFtueState(true);
            props.setFtueGameId(actionCommand.gameTutorial.gameId.toString());
            props.setOnboardingFtueStep(FTUE_STEPS_KEYS.HIGHLIGHT_A_GAME);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function handleDisplayGameTutorialAction(_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

var handleDisplayMissionsTutorialAction = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(actionCommand, props) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            props.setActiveTutorial({
              activeTutorial: true,
              tutorialName: TUTORIAL_NAME.MISSIONS_TUTORIAL,
              blockLobby: true
            });

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function handleDisplayMissionsTutorialAction(_x6, _x7) {
    return _ref5.apply(this, arguments);
  };
}();

var createAction = (_createAction = {}, _defineProperty(_createAction, ACTION_COMMANDS_TYPE.DISPLAY_MODAL, handleDisplayModalAction), _defineProperty(_createAction, ACTION_COMMANDS_TYPE.DISPLAY_TOOLTIP, handleDisplayTooltipAction), _defineProperty(_createAction, ACTION_COMMANDS_TYPE.DISPLAY_GAME_TUTORIAL, handleDisplayGameTutorialAction), _defineProperty(_createAction, ACTION_COMMANDS_TYPE.DISPLAY_MISSIONS_TUTORIAL, handleDisplayMissionsTutorialAction), _defineProperty(_createAction, "default", function _default() {}), _createAction);

var ActionsInterface = function ActionsInterface(props) {
  var _props$actionCommands;

  props.setLastActionExecuted(props.actionCommands[0]);
  createAction[(_props$actionCommands = props.actionCommands[0]) === null || _props$actionCommands === void 0 ? void 0 : _props$actionCommands.actionType](props.actionCommands[0], props) || createAction['default']();
};

export default ActionsInterface;